module.exports = __webpack_public_path__ + "img/user.0a27930a.svg";